import { createFileRoute } from "@tanstack/react-router";

import { AboutPageContent } from "@/components/site/AboutPageContent";
import { SiteShell } from "@/components/site/SiteShell";
import { business } from "@/lib/business";
import { localBusinessJsonLd, pageHead } from "@/lib/seo";

const title = `About Us | ${business.name} in ${business.city}, ${business.state}`;
const description = `Meet ${business.owner} and Champion Automotive Machine Shop in ${business.city}, ${business.state}. Family-run engine machining since ${business.since} — cylinder boring, sleeving, line boring & surfacing, guaranteed to your satisfaction.`;

export const Route = createFileRoute("/about")({
  component: AboutPage,
  head: () => ({
    ...pageHead({ title, description, path: "/about" }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(localBusinessJsonLd(description)),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: title,
          description,
          url: `${business.siteUrl}/about`,
          mainEntity: {
            "@type": "AutoMachineShop",
            name: business.name,
            founder: business.owner,
            foundingDate: "2016-01-01",
          },
        }),
      },
    ],
  }),
});

function AboutPage() {
  return (
    <SiteShell>
      <AboutPageContent />
    </SiteShell>
  );
}
